import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';

export default class Gallery {
	constructor(el) {
		this.swiper = new Swiper(el, {
			slidesPerView: 'auto',
			loop: true,
			loopedSlides: 20,
			spaceBetween: 17,
			grabCursor: true,
			centeredSlides: true,
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
			},
		});

		this.swiper.on('touchMove', (e) => {
			el.dispatchEvent(
				new CustomEvent('gallery-drag', {
					bubbles: true,
					detail: e.touches,
				})
			);
		});
	}
}
